function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { useCallback, useState } from 'react';
import { noop } from '@adsk/alloy-react-helpers';
import { removeOldDuplicatesBy } from '../helpers/removeOldDuplicatesBy';

/**
 * This hook aggregates data from client side, and provides `modifyData` method to reflect those changes on BE data.
 *
 * @param onDataChange
 * @returns {{modifyData: function, addData: function, removeEntityById: function, updateEntity: function}}
 */
export default (function () {
  let onDataChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
  const [removedIds, setRemovedIds] = useState([]);
  const [updatedEntitiesMap, setUpdatedEntitiesMap] = useState({});
  const [addedEntities, setAddedEntities] = useState([]);
  const modifyData = useCallback(data => {
    const handleAdd = d => addedEntities.length ? removeOldDuplicatesBy([...d, ...addedEntities], item => item.id) : d;
    const handleUpdate = d => Object.keys(updatedEntitiesMap).length ? d.map(entity => updatedEntitiesMap[entity.id] || entity) : d;
    const handleRemove = d => removedIds.length ? d.filter(entity => !removedIds.includes(entity.id)) : d;
    return handleUpdate(handleRemove(handleAdd(data)));
  }, [removedIds, updatedEntitiesMap, addedEntities]);
  const addData = useCallback(newData => {
    onDataChange();
    // in next line we are checking if our new user is already in the removeIds.
    // it solves case that the user is re-added after we deleted him.
    setRemovedIds(prevRemoveIds => prevRemoveIds.length ? prevRemoveIds.filter(id => !newData.some(item => item.id === id)) : prevRemoveIds);
    setAddedEntities(prevAddedEntities => [...prevAddedEntities, ...newData]);
  }, [onDataChange]);
  const updateEntity = useCallback(entity => {
    onDataChange();
    setUpdatedEntitiesMap(prevUpdatedEntitiesMap => _objectSpread(_objectSpread({}, prevUpdatedEntitiesMap), {}, {
      [entity.id]: entity
    }));
  }, [onDataChange]);
  const removeEntityById = useCallback(id => {
    onDataChange();
    setRemovedIds(prevIds => [...prevIds, id]);
  }, [onDataChange]);
  return {
    modifyData,
    addData,
    updateEntity,
    removeEntityById
  };
});
//# sourceMappingURL=useClientSideDataModification.js.map